import "./about.css";

const LEADERS = [
  {
    name: "Rajat Rajkumar Gandhi",
    title: "Business Development",
    image: "/images/team/3.jpg",
    bio: "A dynamic business development professional with strong expertise in client relations, strategic partnerships, and market expansion. Rajat brings a growth-oriented approach to GPS Finvest, focusing on building long-term business relationships, identifying new opportunities, and driving sustainable growth through effective communication and business strategies.Focus: Expanding business networks, strengthening client engagement, and creating growth opportunities that align with the company’s vision and long-term success.",
    experience: "15+ Years Experience",
    expertise: "Finance & Investment Expert",
    linkedin: "https://linkedin.com",
  },
  {
    name: "Madhusudan Toshniwal",
    title: "Compliance Officer",
    image: "/images/about/1.jpg",
    bio: "An experienced compliance professional with deep knowledge of regulatory frameworks, corporate governance, and financial compliance standards. Madhusudan ensures that GPS Finvest operates with transparency, integrity, and adherence to all applicable regulations, helping maintain strong operational and ethical standards across the organization. Focus Areas: Regulatory compliance, policy implementation, risk management, and maintaining robust governance practices to support secure and compliant business operations.",
    experience: "12+ Years Experience",
    expertise: "Operations & Growth",
    linkedin: "https://linkedin.com",
  },
  {
    name: "CA Priyanka Soni",
    title: "Principal Officer and Analyst",
    image: "/images/team/2.jpg",
    bio: "A qualified Chartered Accountant with expertise in financial analysis, compliance, taxation, and investment research. Priyanka plays a key role at GPS Finvest by ensuring financial accuracy, regulatory adherence, and insightful market analysis that supports informed financial planning and strategic decision-making. Focus Areas: Financial analysis, regulatory compliance, risk assessment, and delivering data-driven insights for effective investment and business decisions.",
    experience: "10+ Years Experience",
    expertise: "Finance & Compliance Expert",
    linkedin: "https://linkedin.com",
  },
];

export default function AboutLeadership() {
  return (
    <section className="about-leaders">
      <div className="about-leaders-inner">
        <header className="about-section-head">
          <p className="about-eyebrow">OUR LEADERSHIP TEAM</p>
          <h2>Experienced Minds. Stronger Decisions.</h2>
        </header>

        <div className="about-leaders-list">
          {LEADERS.map((person) => (
            <article key={person.name} className="about-leader-card">
              <div className="about-leader-photo">
                <img src={person.image} alt={person.name} />
              </div>
              <div className="about-leader-body">
                <div className="about-leader-top">
                  <div>
                    <h3>{person.name}</h3>
                    <p className="about-leader-role">{person.title}</p>
                  </div>
                  <a
                    href={person.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="about-leader-li"
                    aria-label={`${person.name} on LinkedIn`}
                  >
                    <i className="fa-brands fa-linkedin-in" aria-hidden="true" />
                  </a>
                </div>
                <p className="about-leader-bio">{person.bio}</p>
                <div className="about-leader-meta">
                  <span>
                    <i className="fa-solid fa-clock" aria-hidden="true" />
                    {person.experience}
                  </span>
                  <span>
                    <i className="fa-solid fa-user-gear" aria-hidden="true" />
                    {person.expertise}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="about-leaders-foot">
          Together, we are building a team that is passionate about your
          financial well-being.
        </p>
      </div>
    </section>
  );
}
